import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { Alert, Avatar, IconButton, Stack, Typography } from "@mui/material";
import { Message, Edit, Delete } from "@mui/icons-material";
import { formatDate } from "@progress/kendo-intl";
import {
  toggleDirectorResponseEditModal,
  toggleDirectorResponseDeleteModal,
} from "../../../../../app/slices/VarianceModuleSlice";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";

function DirectorResponseList() {
  const dispatch = useAppDispatch();
  const { data: profileData } = useMyProfileQuery();
  const incident = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );

  const convertedResponses = () => {
    let p = incident?.directorResponses?.map((obj) => {
      return { ...obj, createdDate: new Date(obj.createdDate) };
    });
    return p ?? [];
  };

  const sortedResponses = convertedResponses()
    .slice()
    .sort((a, b) => b.createdDate.getTime() - a.createdDate.getTime());

  const canEditResponse = (response: any) => {
    return profileData?.identity === response.createdBy;
  };

  const handleEditResponse = (response: any) => {
    dispatch(toggleDirectorResponseEditModal(response));
  };

  const handleDeleteResponse = (response: any) => {
    dispatch(toggleDirectorResponseDeleteModal(response));
  };

  const hasLegacyResponse = !!incident?.directorResponse;
  const hasNewResponses = incident?.directorResponses && incident.directorResponses.length > 0;

  return (
    <React.Fragment>
      {!hasNewResponses && !hasLegacyResponse && (
        <Alert color="info" sx={{ margin: "10px 0" }}>
          No director responses have been added yet.
        </Alert>
      )}
      {sortedResponses.map((i, index) => (
        <div
          key={i.directorResponseId || `response-${index}-${i.createdDate.getTime()}`}
          style={{
            borderBottom: "2px solid #62BCBD",
            marginBottom: "5px",
            paddingBottom: "5px",
          }}
        >
          <Stack direction="row" alignItems="center" gap={2} marginLeft="10px">
            <Avatar style={{ backgroundColor: "#1976d2" }}>
              <Message />
            </Avatar>
            <Typography>
              {i.createdBy +
                " on " +
                formatDate(new Date(i.createdDate ?? ""), "MM/dd/yyyy hh:mm")}
              {i.editedDate && (
                <Typography component="span" variant="caption" color="text.secondary" sx={{ marginLeft: 1 }}>
                  (edited by {i.editedBy} on {formatDate(new Date(i.editedDate), "MM/dd/yyyy hh:mm")})
                </Typography>
              )}
            </Typography>
            {canEditResponse(i) && (
              <Stack direction="row" marginLeft="auto">
                <IconButton
                  size="small"
                  onClick={() => handleEditResponse(i)}
                  sx={{ color: "#1976d2" }}
                >
                  <Edit fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => handleDeleteResponse(i)}
                  sx={{ color: "#d32f2f" }}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Stack>
            )}
          </Stack>
          <Typography marginLeft="70px" sx={{ whiteSpace: "pre-wrap" }}>{i.text}</Typography>
        </div>
      ))}
      {hasLegacyResponse && (
        <div
          style={{
            borderBottom: "2px solid #62BCBD",
            marginBottom: "5px",
            paddingBottom: "5px",
          }}
        >
          <Stack direction="row" alignItems="center" gap={2} marginLeft="10px">
            <Avatar style={{ backgroundColor: "#8e8e8e" }}>
              <Message />
            </Avatar>
            <Typography>
              {incident.directorResponseBy
                ? incident.directorResponseBy +
                  " on " +
                  formatDate(new Date(incident.directorResponseDate ?? ""), "MM/dd/yyyy hh:mm")
                : "Original Response"}
            </Typography>
          </Stack>
          <Typography marginLeft="70px" sx={{ whiteSpace: "pre-wrap" }}>{incident.directorResponse}</Typography>
        </div>
      )}
    </React.Fragment>
  );
}

export { DirectorResponseList };
